import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { queryClient } from '@/queries';
import { NewHospitalFormBody, PatchHospitalFormBody } from '@/api/apis/facilities';
import { hospitalQueries } from '@/queries/hospital';
import { hospitalsQueryKeys } from '@/queries/hospital/hospital.keys';

export const useCreateHospitalMutation = () => {
  return useMutation({
    mutationFn: (variables: NewHospitalFormBody & { id: string }) => api.hospital.createHospital(variables),
    meta: {
      invalidates: [hospitalsQueryKeys.getList(), hospitalsQueryKeys.getInfiniteList()],
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(hospitalQueries.item(variables.id).queryKey, data);
    },
  });
};

export const useUpdateHospitalMutation = () => {
  return useMutation({
    mutationFn: (variables: PatchHospitalFormBody & { id: string }) => api.hospital.updateHospitalById(variables),
    meta: {
      invalidates: [hospitalsQueryKeys.getList(), hospitalsQueryKeys.getInfiniteList()],
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: hospitalsQueryKeys.getItem(variables.id) });
    },
  });
};
